module.exports = __webpack_public_path__ + "img/T5-A-xs_04.7276196c.png";